
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load pages for better performance
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/services/detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const ImprintPage = lazy(() => import('../pages/imprint/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/ueber-uns',
    element: <AboutPage />
  },
  {
    path: '/dienstleistungen',
    element: <ServicesPage />
  },
  {
    path: '/dienstleistungen/:slug',
    element: <ServiceDetailPage />
  },
  {
    path: '/kontakt',
    element: <ContactPage />
  },
  {
    path: '/datenschutz',
    element: <PrivacyPage />
  },
  {
    path: '/impressum',
    element: <ImprintPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
